import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { RouteConfig } from '.';

type NavigationProps = {
  route: RouteConfig;
};

const Navigation: FC<NavigationProps> = ({ route, children }) => {
  const isPend = !!route.beforeEnter;
  const [pending, setPending] = React.useState(isPend);
  const params = useParams();

  React.useEffect(() => {
    const nav = async () => {
      const isNext = await route.beforeEnter!(route, params);

      setPending(isNext === false);
    };

    if (isPend) {
      nav();
    }
  }, [isPend, params, route]);

  return <>{pending ? null : children}</>;
};

export default Navigation;
